import { createClient } from '@sanity/client';

import { apiVersion, dataset, projectId, useCdn } from '@dashboard/services/env';

export const sanityClient = createClient({
  apiVersion,
  dataset,
  projectId,
  useCdn,
});
